import CryptoJS from 'crypto-js';
import moment from 'moment';
import { number } from 'prop-types';
export function test() {
	return null;
}

export function getOS() {
	const { userAgent } = window.navigator;
	const { platform } = window.navigator;
	const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
	let os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'MacOS';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (!os && /Linux/.test(platform)) {
		os = 'Linux';
	}

	// @ts-ignore
	document.documentElement.setAttribute('os', os);
	return os;
}
export const DownloadFile = (csvContent: string, outputFileName: string) => {
	const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
	const link = document.createElement('a');
	const url = URL.createObjectURL(blob);
	link.setAttribute('href', url);
	link.setAttribute('download', `${outputFileName}__${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url); // Cleanup
};
export const hasNotch = () => {
	/**
	 * For storybook test
	 */
	const storybook = window.location !== window.parent.location;
	// @ts-ignore
	const iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
	const aspect = window.screen.width / window.screen.height;
	const aspectFrame = window.innerWidth / window.innerHeight;
	return (
		(iPhone && aspect.toFixed(3) === '0.462') ||
		(storybook && aspectFrame.toFixed(3) === '0.462')
	);
};

export const mergeRefs = (refs: any[]) => {
	return (value: any) => {
		refs.forEach((ref) => {
			if (typeof ref === 'function') {
				ref(value);
			} else if (ref != null) {
				ref.current = value;
			}
		});
	};
};

export const randomColor = () => {
	const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger'];

	const color = Math.floor(Math.random() * colors.length);

	return colors[color];
};

export const priceFormat = (price: number) => {
	return price.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	});
};

export const average = (array: any[]) => array.reduce((a, b) => a + b) / array.length;

export const percent = (value1: number, value2: number) =>
	Number(((value1 / value2 - 1) * 100).toFixed(2));

export const getFirstLetter = (text: string, letterCount = 2): string =>
	// @ts-ignore
	text
		.toUpperCase()
		.match(/\b(\w)/g)
		.join('')
		.substring(0, letterCount);

export const debounce = (func: (arg0: any) => void, wait = 1000) => {
	let timeout: string | number | NodeJS.Timeout | undefined;

	return function executedFunction(...args: any[]) {
		const later = () => {
			clearTimeout(timeout);
			// @ts-ignore
			func(...args);
		};

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
};



export function formatDateToString(date:Date):string{
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	const formattedDatetime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	return formattedDatetime;
}

type DateFormatType =
  | "ToServer"
  | "FromServer"

export function FormatSystemDateTime(date:Date,gmtOffset:string | undefined,serverGmtOffset:string | undefined,formatType:DateFormatType):string{
	if (! serverGmtOffset || !gmtOffset || serverGmtOffset.length==0 || gmtOffset.length==0){
		return ""
	}
	date = AddSystemOffset(date,gmtOffset,serverGmtOffset,formatType);
	return formatDateToString(date); 
	
	
}
export function AddSystemOffset(date:Date,gmtOffset:string | undefined,serverGmtOffset:string|undefined,formatType:DateFormatType):Date{
	switch  (formatType) {
		case "FromServer":
			date.setHours(date.getHours()+Number(gmtOffset))
			date.setHours(date.getHours()+Number(serverGmtOffset)*-1)
			return date
		case "ToServer":
			date.setHours(date.getHours()+Number(gmtOffset)*-1)
			date.setHours(date.getHours()+Number(serverGmtOffset))
			return date
		default:
			return new Date()
	}
}

export function getInactiveDays(date1: Date | string, date2: Date | string): number {
  if (!date1 || !date2) return 0;

  const d1 = new Date(date1);
  const d2 = new Date(date2);

  const diffMs = d1.getTime() - d2.getTime();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24)); // ms → days
}



export const getLastLogin = (loginTimestamp: number): string => {
  const DEFAULT_LAST_LOGIN = new Date(0); // 1970-01-01 UTC

  const storedLastLogin = localStorage.getItem("ark_lastLogin");
  const storedCurrentLogin = localStorage.getItem("ark_currentLogin");

  let lastLogin = storedLastLogin
    ? new Date(parseInt(storedLastLogin, 10))
    : DEFAULT_LAST_LOGIN;

  let currentLogin = storedCurrentLogin
    ? new Date(parseInt(storedCurrentLogin, 10))
    : new Date(loginTimestamp);

  if (!storedCurrentLogin || loginTimestamp > currentLogin.getTime()) {
    lastLogin = currentLogin;
    currentLogin = new Date(loginTimestamp);
  } else if (loginTimestamp < currentLogin.getTime()) {
    lastLogin = new Date(loginTimestamp);
  }

  localStorage.setItem("ark_lastLogin", lastLogin.getTime().toString());
  localStorage.setItem("ark_currentLogin", currentLogin.getTime().toString());

  return formatDateToString(lastLogin)
};






export const formatNumber = (num: number, precision = 2) => {
	return Number(num?.toFixed(precision) || 0).toLocaleString('en-US', {
		minimumFractionDigits: precision,
		maximumFractionDigits: precision,
	});
};

// Encryption function
export function encryptText(text: string, secretKey: string): string {
	const encrypted = CryptoJS.AES.encrypt(text, secretKey).toString();
	// Convert to Base64 URL-safe encoding
	return encodeURIComponent(encrypted);
}

// Decryption function
export function decryptText(encryptedText: string, secretKey: string): string {
	// Decode the URL-safe format
	const decodedText = decodeURIComponent(encryptedText);
	const bytes = CryptoJS.AES.decrypt(decodedText, secretKey);
	return bytes.toString(CryptoJS.enc.Utf8);
}


// utils/searchFilter.ts
export function searchFilter<T>(
  items: T[],
  search: string,
  extractors: Array<(item: T) => string | number | null | undefined>
): T[] {
  if (!search.trim()) return items;

  const lower = search.toLowerCase();

  return items.filter(item =>
    extractors.some(extractor => {
      const value = extractor(item);
      if (value == null) return false;
      return value.toString().toLowerCase().includes(lower);
    })
  );
}

